var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-faq" }, [
    _c("div", { staticClass: "faq-title" }, [
      _vm._v(_vm._s(_vm.getConstants("FAQ")))
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "faq-content" },
      _vm._l(9, function(i) {
        return _c("div", { key: i, staticClass: "faq-ct-item" }, [
          _c("p", { staticClass: "faq-ct-title" }, [
            _vm._v(
              "\n\t\t\t\t" +
                _vm._s(_vm.getConstants("PRICING_NEW_FAQ_REQUEST" + i)) +
                "\n\t\t\t"
            )
          ]),
          _vm._v(" "),
          _c("p", {
            staticClass: "faq-ct-text",
            domProps: {
              innerHTML: _vm._s(_vm.getConstants("PRICING_NEW_FAQ_ANSWER" + i))
            }
          })
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }